export const locale = {
  en: {
    externalUserRegistration: {
      statuses: {
        activated: 'Active',
        approved: 'Pending user activation',
        denied: 'Denied',
        disabled: 'Disabled',
        expiring: 'Expiring',
        expired: 'Expired',
        pending: 'Pending manager approval',
        revoked: 'Revoked',
      },
    },
  },
};
